import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Destinations.css';

const DESTINATIONS = [
  {
    region: 'Amériques',
    image: require('../../assets/777.jpg'),
    countries: ['États-Unis', 'Canada', 'Brésil', 'Mexique', 'Argentine'],
    highlight: 'New York · Los Angeles · Toronto',
    description: 'Corridors transatlantiques quotidiens avec nos partenaires American Airlines et Air Canada.',
    color: '#E8DCC8',
    textAccent: '#8B6914',
  },
  {
    region: 'Europe',
    image: require('../../assets/50289.jpg'),
    countries: ['France', 'Allemagne', 'Belgique', 'Espagne', 'Italie', 'Suisse'],
    highlight: 'Paris · Londres · Francfort',
    description: "Hub européen certifié avec procédures douanières simplifiées pour l'espace Schengen.",
    color: '#D4E4F7',
    textAccent: '#1A3355',
  },
  {
    region: 'Asie-Pacifique',
    image: require('../../assets/3594.jpg'),
    countries: ['Japon', 'Australie', 'Singapour', 'Chine', 'EAU', 'Thaïlande'],
    highlight: 'Tokyo · Sydney · Singapour',
    description: 'Expertise des réglementations strictes australiennes et asiatiques pour un transit sans accroc.',
    color: '#D4EDD8',
    textAccent: '#1A4A22',
  },
  {
    region: 'Afrique & Moyen-Orient',
    image: require('../../assets/18108.jpg'),
    countries: ['Maroc', 'Sénégal', 'Afrique du Sud', 'Dubaï', 'Qatar', 'Israël'],
    highlight: 'Dubaï · Casablanca · Johannesburg',
    description: 'Partenariats privilégiés avec Emirates SkyCargo et les compagnies africaines de référence.',
    color: '#EDD8C8',
    textAccent: '#7A3C14',
  },
];

export default function Destinations({ trackEvent }) {
  const [active, setActive] = useState(0);

  const handleSelect = (index, region) => {
    setActive(index);
    // Tracking : changement de destination
    trackEvent('destination_select', { region, index });
  };

  return (
    <section id="destinations" className="destinations" data-tracking-name="Destinations">
      <div className="destinations-container">

        {/* En-tête */}
        <motion.div
          className="destinations-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7 }}
        >
          <span className="section-label">Présence mondiale</span>
          <h2 className="section-title">
            Nous opérons partout<br />où vous en avez besoin
          </h2>
        </motion.div>

        {/* Layout principal */}
        <div className="destinations-layout">

          {/* Tabs de sélection */}
          <motion.div
            className="destinations-tabs"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7, delay: 0.1 }}
          >
            {DESTINATIONS.map((dest, i) => (
              <button
                key={dest.region}
                className={`dest-tab ${active === i ? 'active' : ''}`}
                onClick={() => handleSelect(i, dest.region)}
              >
                <span className="dest-tab-emoji"></span>
                <span className="dest-tab-label">{dest.region}</span>
                <span className="dest-tab-count">{dest.countries.length} pays</span>
              </button>
            ))}
          </motion.div>

          {/* Panneau de détail */}
          <motion.div
            className="destinations-panel-wrapper"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            <AnimatePresence mode="wait">
              <motion.div
                key={active}
                className="destinations-panel"
                style={{ '--panel-bg': DESTINATIONS[active].color, '--panel-accent': DESTINATIONS[active].textAccent }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.4, ease: 'easeOut' }}
              >
                {/* Titre du panneau */}
                <div className="panel-header">
                  {/* <span className="panel-emoji">
                    
                  
                  </span> */}
                  <div>
                    <h3 className="panel-title">{DESTINATIONS[active].region}</h3>
                    <span className="panel-highlight">{DESTINATIONS[active].highlight}</span>
                  </div>
                </div>

                {/* Description */}
                <p className="panel-desc">{DESTINATIONS[active].description}</p>

                {/* Pays en tags */}
                <div className="panel-countries">
                  {DESTINATIONS[active].countries.map((country) => (
                    <span key={country} className="country-tag">{country}</span>
                  ))}
                </div>

                {/* Carte monde stylisée SVG */}
                <div className="panel-map" style={{backgroundImage: `url(${DESTINATIONS[active].image})`, backgroundPosition: 'center', backgroundSize: 'cover'}}>
              
                </div>

                {/* Stat bottom */}
                <div className="panel-footer">
                  <div className="panel-stat">
                    <span className="ps-value">{DESTINATIONS[active].countries.length}</span>
                    <span className="ps-label">Pays desservis</span>
                  </div>
                  <div className="panel-stat">
                    <span className="ps-value">7j/7</span>
                    <span className="ps-label">Opérationnel</span>
                  </div>
                  <div className="panel-stat">
                    <span className="ps-value">24h</span>
                    <span className="ps-label">Réponse max</span>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
